<section
    class="shared-inboxes"
    aria-labelledby="shared-inboxes-heading"
>
    <div class="shared-inboxes-header">
        <h3 id="shared-inboxes-heading">Shared Inboxes</h3>
        <p
            id="shared-inboxes-help"
            class="text-muted mb-0"
        >Email addresses that are not HOMER users, such as the business office. Each is sent the PDF of every attested invoice.</p>
    </div>

    <form
        class="add-inbox"
        [formGroup]="form"
        (ngSubmit)="add()"
        aria-describedby="shared-inboxes-help"
    >
        <div class="add-inbox-field">
            <label
                for="shared-inbox-email"
                class="required-field"
            >Email</label>
            <input
                pInputText
                id="shared-inbox-email"
                type="email"
                formControlName="email"
                autocomplete="off"
                maxlength="256"
                placeholder="name@flhealth.gov"
                aria-required="true"
                [attr.aria-invalid]="emailError ? true : null"
                [attr.aria-describedby]="emailError ? 'shared-inbox-email-error' : null"
            />
            @if (emailError) {
                <small
                    id="shared-inbox-email-error"
                    class="text-danger"
                    role="alert"
                >{{ emailError }}</small>
            }
        </div>

        <div class="add-inbox-field">
            <label for="shared-inbox-name">Name</label>
            <input
                pInputText
                id="shared-inbox-name"
                type="text"
                formControlName="name"
                autocomplete="off"
                maxlength="100"
                placeholder="Business Office"
                [attr.aria-invalid]="nameError ? true : null"
                [attr.aria-describedby]="nameError ? 'shared-inbox-name-error' : null"
            />
            @if (nameError) {
                <small
                    id="shared-inbox-name-error"
                    class="text-danger"
                    role="alert"
                >{{ nameError }}</small>
            }
        </div>

        <p-button
            type="submit"
            label="Add Inbox"
            icon="pi pi-plus"
            styleClass="add-inbox-button"
            [loading]="isSaving()"
        />
    </form>

    @if (inboxes() === null) {
        <p-skeleton height="2.5rem" />
    } @else {
        <p-table
            class="w-100"
            [value]="inboxes()"
            [dt]="tableDts"
            stripedRows
        >
            <ng-template #header>
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Email</th>
                    <th
                        scope="col"
                        class="inbox-remove"
                    >
                        <span class="sr-only">Remove</span>
                    </th>
                </tr>
            </ng-template>

            <ng-template
                #body
                let-inbox
            >
                <tr>
                    <td>{{ inbox.name || '-' }}</td>
                    <td class="inbox-email">{{ inbox.email }}</td>
                    <td class="text-right inbox-remove">
                        <p-button
                            icon="pi pi-trash"
                            severity="danger"
                            [text]="true"
                            [rounded]="true"
                            [ariaLabel]="'Remove ' + inbox.email"
                            (click)="confirmRemove(inbox)"
                        />
                    </td>
                </tr>
            </ng-template>

            <ng-template #emptymessage>
                <tr>
                    <td
                        class="text-center"
                        colspan="3"
                    >No shared inboxes. Attested invoices are only emailed to the selected contacts below.</td>
                </tr>
            </ng-template>
        </p-table>
    }
</section>
